import { Row, Col, Card, Typography, Button, Collapse, Tag } from 'antd';
import { DownloadOutlined, CalendarOutlined, CheckCircleOutlined, ClockCircleOutlined } from '@ant-design/icons';
import './Commissions.css';

const { Title, Text } = Typography;
const { Panel } = Collapse;

const Commissions = () => {

  const monthlyStatements = [
    {
      month: 'December 2024',
      clients: 2,
      amount: '$1,300',
      status: 'pending',
      managedMRR: '$2,900',
      commissionRate: '40%',
      grossCommission: '$1,100',
      adjustments: '—',
      breakdown: [
        { client: 'ProShine Auto Detailing', mrr: '$650', commission: '$260' },
        { client: 'Blue Ridge HVAC', mrr: '$2,250', commission: '$900' }
      ],
      paidDate: null
    },
    {
      month: 'November 2024',
      clients: 2,
      amount: '$1,300',
      status: 'paid',
      managedMRR: '$2,900',
      commissionRate: '40%',
      grossCommission: '$1,100',
      adjustments: '—',
      breakdown: [
        { client: 'ProShine Auto Detailing', mrr: '$650', commission: '$260' },
        { client: 'Blue Ridge HVAC', mrr: '$2,250', commission: '$900' }
      ],
      paidDate: '12/5/2024'
    },
    {
      month: 'October 2024',
      clients: 2,
      amount: '$1,190',
      status: 'paid',
      managedMRR: '$2,900',
      commissionRate: '40%',
      grossCommission: '$1,100',
      adjustments: '—',
      breakdown: [
        { client: 'ProShine Auto Detailing', mrr: '$650', commission: '$260' },
        { client: 'Blue Ridge HVAC', mrr: '$2,250', commission: '$900' }
      ],
      paidDate: '11/5/2024'
    },
    {
      month: 'September 2024',
      clients: 2,
      amount: '$1,160',
      status: 'paid',
      managedMRR: '$2,900',
      commissionRate: '40%',
      grossCommission: '$1,100',
      adjustments: '—',
      breakdown: [
        { client: 'ProShine Auto Detailing', mrr: '$650', commission: '$260' },
        { client: 'Blue Ridge HVAC', mrr: '$2,250', commission: '$800' }
      ],
      paidDate: '10/5/2024'
    },
    {
      month: 'August 2024',
      clients: 2,
      amount: '$1,080',
      status: 'paid',
      managedMRR: '$2,700',
      commissionRate: '40%',
      grossCommission: '$1,080',
      adjustments: '—',
      breakdown: [
        { client: 'ProShine Auto Detailing', mrr: '$650', commission: '$260' },
        { client: 'Blue Ridge HVAC', mrr: '$2,050', commission: '$820' }
      ],
      paidDate: '9/5/2024'
    }
  ];

  const currentMonthBreakdown = [
    { client: 'ProShine Auto Detailing', products: ['RouteIQ', 'ProximityIQ'], mrr: '$733', rate: '40%', commission: '$293.2' },
    { client: 'Blue Ridge HVAC', products: ['RouteIQ', 'ProximityIQ'], mrr: '$2,206', rate: '40%', commission: '$882.4' }
  ];

  return (
    <div className="reseller-commissions">
      {/* Header */}
      <div className="commissions-header">
        <div>
          <Title level={2} style={{ margin: 0 }}>Commission Tracking</Title>
          <Text type="secondary">ServiceTech Marketing Partners</Text>
        </div>
        <div className="last-updated">Last updated: 7:44:58 PM</div>
      </div>

      {/* Page Title */}
      <div className="page-title-section">
        <Title level={3} style={{ margin: 0 }}>Commission Tracking</Title>
        <Text type="secondary">Your earnings and payout history</Text>
      </div>

      {/* Stats Cards */}
      <Row gutter={16} className="commission-stats">
        <Col span={6}>
          <Card className="stat-card-commission">
            <Text type="secondary">This Month</Text>
            <div className="stat-value-commission">$1,175.6</div>
            <Text type="secondary" style={{ fontSize: 12 }}>Estimated payout</Text>
          </Card>
        </Col>
        <Col span={6}>
          <Card className="stat-card-commission">
            <Text type="secondary">Total Paid Out</Text>
            <div className="stat-value-commission">$5,023.6</div>
            <Text type="secondary" style={{ fontSize: 12 }}>All-time earnings</Text>
          </Card>
        </Col>
        <Col span={6}>
          <Card className="stat-card-commission">
            <Text type="secondary">Commission Rate</Text>
            <div className="stat-value-commission">40%</div>
            <Text type="secondary" style={{ fontSize: 12 }}>Both products</Text>
          </Card>
        </Col>
        <Col span={6}>
          <Card className="stat-card-commission">
            <Text type="secondary">Managed MRR</Text>
            <div className="stat-value-commission">$2,939</div>
            <Text type="secondary" style={{ fontSize: 12 }}>Total client revenue</Text>
          </Card>
        </Col>
      </Row>

      {/* Monthly Statements */}
      <Card className="monthly-statements-card">
        <div className="statements-header">
          <div>
            <div className="section-icon">
              <CalendarOutlined />
            </div>
            <div>
              <Title level={4} style={{ margin: 0 }}>Monthly Statements</Title>
              <Text type="secondary">Detailed payout history by month</Text>
            </div>
          </div>
        </div>

        <Collapse
          accordion
          className="statements-collapse"
          expandIconPosition="end"
        >
          {monthlyStatements.map((statement, index) => (
            <Panel
              key={index}
              header={
                <div className="statement-header">
                  <div className="statement-month">
                    <CalendarOutlined />
                    <div>
                      <Text strong>{statement.month}</Text>
                      <br />
                      <Text type="secondary" style={{ fontSize: 12 }}>{statement.clients} clients</Text>
                    </div>
                  </div>
                  <div className="statement-amount">
                    <Text strong style={{ fontSize: 18, color: '#16a34a' }}>{statement.amount}</Text>
                    {statement.status === 'paid' ? (
                      <Tag color="green" icon={<CheckCircleOutlined />}>Paid</Tag>
                    ) : (
                      <Tag color="orange" icon={<ClockCircleOutlined />}>Pending</Tag>
                    )}
                  </div>
                </div>
              }
            >
              <div className="statement-details">
                <Row gutter={16} style={{ marginBottom: 24 }}>
                  <Col span={6}>
                    <Text type="secondary">Managed MRR</Text>
                    <div className="detail-value">{statement.managedMRR}</div>
                  </Col>
                  <Col span={6}>
                    <Text type="secondary">Commission Rate</Text>
                    <div className="detail-value">{statement.commissionRate}</div>
                  </Col>
                  <Col span={6}>
                    <Text type="secondary">Gross Commission</Text>
                    <div className="detail-value">{statement.grossCommission}</div>
                  </Col>
                  <Col span={6}>
                    <Text type="secondary">Adjustments</Text>
                    <div className="detail-value">{statement.adjustments}</div>
                  </Col>
                </Row>

                <div className="client-breakdown-section">
                  <Text strong>Client Breakdown</Text>
                  <table className="breakdown-table">
                    <thead>
                      <tr>
                        <th>Client</th>
                        <th align="right">MRR</th>
                        <th align="right">Commission</th>
                      </tr>
                    </thead>
                    <tbody>
                      {statement.breakdown.map((item, idx) => (
                        <tr key={idx}>
                          <td>
                            <Text strong style={{ color: '#1e40af' }}>{item.client}</Text>
                          </td>
                          <td align="right">{item.mrr}</td>
                          <td align="right">
                            <Text strong style={{ color: '#16a34a' }}>{item.commission}</Text>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                {statement.paidDate && (
                  <div className="paid-info">
                    <Text type="secondary">Paid on {statement.paidDate}</Text>
                    <Button type="link" icon={<DownloadOutlined />}>
                      Download Statement
                    </Button>
                  </div>
                )}
              </div>
            </Panel>
          ))}
        </Collapse>
      </Card>

      {/* Commission Structure */}
      <Card className="commission-structure-card">
        <Title level={4}>Commission Structure</Title>
        <Text type="secondary">How your commissions are calculated</Text>

        <Row gutter={16} style={{ marginTop: 24 }}>
          <Col span={12}>
            <Card className="structure-card">
              <Text type="secondary">Single Product</Text>
              <div className="structure-rate">20%</div>
              <Text type="secondary" style={{ fontSize: 12 }}>RouteIQ OR ProximityIQ only</Text>
            </Card>
          </Col>
          <Col span={12}>
            <Card className="structure-card highlighted">
              <Text type="secondary">Both Products</Text>
              <div className="structure-rate">40%</div>
              <Text type="secondary" style={{ fontSize: 12 }}>RouteIQ + ProximityIQ</Text>
            </Card>
          </Col>
        </Row>
      </Card>

      {/* Current Month Breakdown */}
      <Card className="current-month-card">
        <Title level={4}>Current Month Breakdown</Title>

        <table className="current-month-table">
          <thead>
            <tr>
              <th>Client</th>
              <th>Products</th>
              <th align="right">MRR</th>
              <th align="right">Rate</th>
              <th align="right">Commission</th>
            </tr>
          </thead>
          <tbody>
            {currentMonthBreakdown.map((item, idx) => (
              <tr key={idx}>
                <td>
                  <Text strong style={{ color: '#1e40af' }}>{item.client}</Text>
                </td>
                <td>
                  {item.products.map((product, i) => (
                    <Tag key={i} color="blue" style={{ marginRight: 4 }}>
                      {product}
                    </Tag>
                  ))}
                </td>
                <td align="right">{item.mrr}</td>
                <td align="right">{item.rate}</td>
                <td align="right">
                  <Text strong style={{ color: '#16a34a', fontSize: 16 }}>{item.commission}</Text>
                </td>
              </tr>
            ))}
            <tr className="total-row">
              <td colSpan={4}>
                <Text strong>Total</Text>
              </td>
              <td align="right">
                <Text strong style={{ fontSize: 18 }}>$1,175.6/mo</Text>
              </td>
            </tr>
          </tbody>
        </table>
      </Card>
    </div>
  );
};

export default Commissions;
